module.exports = __webpack_public_path__ + "static/media/set-vice-captain.svg.d3f611b1.png";